import { render } from "./DeviationCrewChangeInput.vue?vue&type=template&id=79d0e335"
import script from "./DeviationCrewChangeInput.vue?vue&type=script&lang=ts"
export * from "./DeviationCrewChangeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script